import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import {
  injectTopMakesToOptions,
  skipTopMakes,
} from 'shared/components/SearchPanel/transformOptions';
import Select from 'react-select';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import RegexpInput from 'shared/components/RegexpInput/RegexpInput';
import { sortCollection } from 'shared/helpers/arrays';
import UpdatedSelect from '../../UpdatedSelect/UpdatedSelect';
import s from './DealersPanel.css';

class DealersPanel extends React.Component {
  static propTypes = {
    selectedActions: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    formData: PropTypes.shape().isRequired,
    //
    intl: intlShape.isRequired,
  };

  handleTradeInToggle = () => {
    const { formState, selectedActions } = this.props;
    selectedActions.set.tradeIn(!formState.tradeIn ? 1 : null);
  };

  handleCreditToggle = () => {
    const { formState, selectedActions } = this.props;
    selectedActions.set.credit(!formState.credit ? 1 : null);
  };

  handleOfficialToggle = () => {
    const { formState, selectedActions } = this.props;
    selectedActions.set.isOfficial(!formState.isOfficial ? 1 : null);
  };

  handleTestDriveToggle = () => {
    const { formState, selectedActions } = this.props;
    selectedActions.set.testDrive(!formState.testDrive ? 1 : null);
  };

  render() {
    const { formVocabulary, formState, formData, selectedActions, intl } = this.props;

    const { makes, categories } = formVocabulary;
    const { models } = formData;
    const makesWithTopMakes = injectTopMakesToOptions(makes, intl);

    sortCollection(models, 'title');
    sortCollection(categories, 'title');

    const selectedSetActions = selectedActions.set;

    return (
      <div>
        <div className={s.mainform}>
          <div className={s.filterItem}>
            <Select
              placeholder={intl.formatMessage({ id: 'Марка' })}
              instanceId="make-ff"
              name="make"
              options={makesWithTopMakes}
              labelKey="title"
              valueKey="id"
              disabled={!makes || !makes.length}
              onChange={selectedSetActions.make}
              value={formState.make}
              filterOption={skipTopMakes}
            />
          </div>
          <div className={s.filterItem}>
            <UpdatedSelect
              instanceId="model-ff"
              name="model"
              placeholder={intl.formatMessage({ id: 'Модель' })}
              labelKey="title"
              valueKey="id"
              disabled={!models || !models.length}
              options={models && models.length > 0 ? models : []}
              onChange={selectedSetActions.model}
              value={formState.model}
              matchPos="start"
            />
          </div>
          <div className={s.filterItem}>
            <RegexpInput
              className={s.input}
              type="text"
              placeholder={intl.formatMessage({ id: 'Название дилера' })}
              value={formState.q || ''}
              onChange={selectedSetActions.q}
            />
          </div>
          <div className={s.filterItem}>
            <div className={s.checkboxContainer}>
              <label className={s.checkbox}>
                <input
                  type="checkbox"
                  onChange={this.handleOfficialToggle}
                  checked={!!formState.isOfficial}
                />{' '}
                <FormattedMessage id="Только официальные" />
              </label>
            </div>
          </div>
          <div className={s.filterItem}>
            <div className={s.checkboxContainer}>
              <label className={s.checkbox}>
                <input
                  type="checkbox"
                  onChange={this.handleTradeInToggle}
                  checked={!!formState.tradeIn}
                />{' '}
                Trade In (
                <FormattedMessage id="Обмен старого на новый" />)
              </label>
            </div>
          </div>
          <div className={s.filterItem}>
            <div className={s.flexContainer}>
              <div className={s.left}>
                <label className={s.checkbox}>
                  <input
                    type="checkbox"
                    onChange={this.handleTestDriveToggle}
                    checked={!!formState.testDrive}
                  />{' '}
                  <FormattedMessage id="Тест-драйв" />
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(DealersPanel));



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanel/DealersPanel/DealersPanel.js